import { DecimalPipe, DatePipe } from '@angular/common';
import { NotificationService } from "src/app/shared/services/notification.service";
import * as moment from "moment";
import { Subscriber } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service'; 
import { SharedDataService } from 'src/app/shared/services/sharedata.service';

export function displayErrorMessage(
    { notification, response, formControl = null }: 
    { notification: NotificationService; response: object | any; formControl?: any; }
) {
    if(response && response['type'] && response['type'] === 'array') {
        let errors = response.data ? Object.entries(response.data.message): Object.entries(response.message);
        if(!!formControl) {
            errors.forEach(err => {
                formControl[err[0]] && formControl[err[0]].setErrors({ validation: true, message: err[1] });
            });
            // notification.warning("Validation error occurred!", 3000);
        }else {
            let errMsgLength = response.data ? Object.keys(response.data.message).length : Object.keys(response.message).length;
            let message = '';
            if(response.data) {
                errors.forEach((err , i) => {
                    let comma = (errMsgLength-1) !== i ? ", ":'';
                    message += response.data.message[err[0]][0]+ comma;
                });
            } else {
                message = response.message[0]
            }
          
            notification.warning(message);
        }
    }else {
        notification.warning("Validation error occurred! - " + response['message'], 5000);
    }
}

export function removeWhiteSpaces(value: string) {
    if(value !== null) {
        let regex = /\s+/g;
        return value.replace(regex, '');
    } 
}

export function explode(value: string, delimiter: string) {
    if(value !== null && value !== undefined && typeof value === 'string') {
        return value.split(delimiter);
    } else {
        return []; // Return empty array for null, undefined, or non-string values
    }
}

export function implode(value: Array<any>, delimiter: string) {
    if(value.length > 0) {
        return value.join(delimiter);
    } 
}

export function strReplace(value: string, searchKey: string, replaceKey: string) {
    if(value !== null) {
        return value.replace(searchKey, replaceKey);
    }else {
        return null;
    }
}

export function parseDateFormat(
    datePipe: DatePipe,
    date: any,
    checkTz: boolean,
    dayFmt: string, 
    monthFmt: string, 
    yearFmt: string, 
    delimiter: string, 
    optional?: string
): string {
    let newFormat = [dayFmt, monthFmt, yearFmt];
    let storeData = JSON.parse(sessionStorage.getItem('store'));
    let storeDateFormat = !!storeData ? storeData['date_format'] : '';
    let storeTimeZone = !!storeData ? storeData['time_zone'] : '';
    storeTimeZone = storeTimeZone.toString();
    let formatedDate = null;
    if(!!storeDateFormat) {
        let storeFormat = explode(storeDateFormat, "/");
        storeFormat = storeFormat.map(el => el.slice(0,1).toLowerCase());
        storeFormat.forEach((el, i) => {
            newFormat[i] = el == 'd' ? dayFmt : el == 'm' ? monthFmt : yearFmt;
        })
    }
    let newDateFormat = implode(newFormat, delimiter);
    if(!!optional) {
        newDateFormat += optional;
    }
    if(!!storeTimeZone && checkTz) {
        formatedDate = datePipe.transform(date, newDateFormat, storeTimeZone);
    }else {
        formatedDate = datePipe.transform(date, newDateFormat);
    }
    return formatedDate;
}

// if check allow to create order (OR) add product start
export function isAllowToCreateOrderOrAddProduct(dialog, dialogComponent, params) {
    let selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    let featureTags = JSON.parse(sessionStorage.getItem('featureTags'));
    let deliveryDate = moment();
    if (!!selectedDeliveryCalendar) {
        deliveryDate = moment(selectedDeliveryCalendar['delivery_date']);
    }
    let unconfirmed_order = sessionStorage.getItem('unconfirmed_order');
    let stphone = sessionStorage.getItem('stphone');
    let stemail = sessionStorage.getItem('stemail');

    let bookingStartDate = JSON.parse(sessionStorage.getItem('booking_start_date'));

    if (isDeliveryCalendarExist()) {
        if (checkDeliveryCalendarOrderStatus("delivered")) {
            dialog.open(dialogComponent, {
                maxWidth: '90vw', width: '360px',
                data: {
                    title: 'Over and done',
                    displayMessage: 'You are trying to add a product for a delivery schedule that has ended.',
                    ...params, msg: 'delivered order or cutofftime exist'
                }
            });
            return false;
        }else if ((checkOrderStartDate('<') || (checkOrderStartDate('===') && checkOrderStartTime('<')))) {
            dialog.open(dialogComponent, {
                maxWidth: '90vw', width: '360px',
                data: {
                    title: 'Order Availability Notice',
                    displayMessage: `You cannot place an order before ${moment(bookingStartDate).format('MM/DD/YYYY HH:mm')}. Please email ${stemail} OR call us at ${stphone} for help.`,
                    ...params, msg: 'order start date'
                }
            });
            return false;
        } else if (((checkCutoffDate('!==') && checkCutoffDate('<')) || checkCutoffDate('===') && checkCutoffTime('>'))) {
            dialog.open(dialogComponent, {
                maxWidth: '90vw', width: '360px',
                data: {
                    title: 'Order cutoff time',
                    displayMessage: `You have crossed the ordering cutoff time for your delivery dated ${deliveryDate.format('MM/DD')}. Please email us ${stemail} OR call us at ${stphone} for help.`,
                    ...params, msg: 'delivered order or cutofftime exist'
                }
            });
            return false;
        }
    } else {
        if (!!unconfirmed_order && unconfirmed_order === "exist") {
            dialog.open(dialogComponent, {
                maxWidth: '90vw', width: '360px',
                data: { ...params, msg: 'unconfirmed order exist' }
            });
            return false;
        }
    }
    return true;
}

export function checkOrderStartDate(operator: string): boolean {
    // Retrieve the cutoff time from sessionStorage
    const cutOffTime = sessionStorage.getItem('cutoff') ? JSON.parse(sessionStorage.getItem('cutoff')) : null;
  
    // If cutOffTime is null, handle it here (return false or any fallback logic)
    if (!cutOffTime || !cutOffTime[0] || !cutOffTime[0]['currentDateAndtime']) {
      console.warn('cutOffTime or currentDateAndtime is null or invalid');
      return false; // or you could decide to return true depending on your logic
    }
  
    // Extract current date and time
    const currentDateAndtime = cutOffTime[0]['currentDateAndtime'];
    const currentDatePart = currentDateAndtime.split(' ')[0]; // Extracting date part
  
    // Retrieve booking start date from sessionStorage
    const bookingStartDate = sessionStorage.getItem('booking_start_date') ? JSON.parse(sessionStorage.getItem('booking_start_date')) : null;
  
    // If bookingStartDate is null, handle it here (return false or any fallback logic)
    if (!bookingStartDate) {
      console.warn('booking_start_date is null or invalid');
      return false;
    }
  
    const bookingStartDatePart = bookingStartDate.split(' ')[0]; // Extracting date part
  
    let returnData = false;
  
    // Switch logic based on the operator
    switch (operator) {
      case "<":
        returnData = currentDatePart < bookingStartDatePart;
        break;
  
      case "===":
        returnData = currentDatePart === bookingStartDatePart;
        break;
  
      default:
        returnData = false;
        break;
    }
  
    return returnData;
  }
  
export function checkOrderStartTime(operator: string): boolean{
    let cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    let currentDateAndtime = cutOffTime[0]['currentDateAndtime'];
    let currentTimePart = currentDateAndtime.split(' ')[1];
    let bookingStartDate = JSON.parse(sessionStorage.getItem('booking_start_date'));
    let bookingStartTimePart
    if(bookingStartDate){
        bookingStartTimePart = bookingStartDate.split(' ')[1];
    }
    let returnData = false;    
    switch(operator){
        case "<": returnData =  currentTimePart < bookingStartTimePart;
            break;

        default:
            returnData = false;
            break;
    }
    return returnData;
}
/** END  */

/** Check Delivery Calendar and CutOff Date & Time */
export function isDeliveryCalendarExist(): boolean {
    let selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    return !!selectedDeliveryCalendar;
}

export function checkDeliveryCalendarOrderStatus(status: string): boolean {
    let selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    let sale_orders = !!selectedDeliveryCalendar && selectedDeliveryCalendar['sale_orders'];
    if(sale_orders instanceof Array)
        return sale_orders && sale_orders.includes(status);
    else
        return false;
}


export function checkCutoffDate(operator: string, comparedFrom?: any, comparedTo?: any): boolean {
    let cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    let orderDeliveryDate = cutOffTime.length > 0 ? cutOffTime[0]['orderDeliveryDate'] : null;
    let storeDeliveryDate = cutOffTime.length > 0 ? cutOffTime[0]['storeDeliveryDate'] : null;
    if(!!comparedFrom && !!comparedTo) {
        orderDeliveryDate = comparedFrom;
        storeDeliveryDate = comparedTo;
    }
    if(!!orderDeliveryDate && !!storeDeliveryDate) {
        let returnData = false;
        switch (operator) {
            case "===":
            case "==":
            returnData = orderDeliveryDate === storeDeliveryDate;
            break;
            case "!==":
            case "!=":
            returnData = orderDeliveryDate !== storeDeliveryDate;
            break;
            case "<":
            returnData = orderDeliveryDate < storeDeliveryDate;
            break;
            case ">":
            returnData = orderDeliveryDate > storeDeliveryDate;
            break;
        
            default:
            returnData = false;
            break;
        }
        return returnData;
    }else {
        return false;
    }
}

export function checkCutoffTime(operator: string, comparedFrom?: any, comparedTo?: any): boolean {
    let cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    let currentDateAndtime = cutOffTime.length > 0 ? cutOffTime[0]['currentDateAndtime'] : null;
    let storeCutOffTime = cutOffTime.length > 0 ? cutOffTime[0]['storeCutOffTime'] : null;
    if(!!comparedFrom && !!comparedTo) {
        currentDateAndtime = comparedFrom;
        storeCutOffTime = comparedTo;
    }
    if(!!currentDateAndtime && !!storeCutOffTime) {
        let returnData = false;
        switch (operator) {
            case "<":
            returnData = currentDateAndtime < storeCutOffTime;
            break;
            case ">":
            returnData = currentDateAndtime > storeCutOffTime;
            break;
        
            default:
            returnData = false;
            break;
        }
        return returnData;
    }else {
        return false;
    }
}
  /** End */
export function checkDeliveryCalenderAndCutOffTime(): boolean {
    let selectedDeliveryCalendar = {};
    let cutOffTime = [];
    selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    if( (selectedDeliveryCalendar !== null && selectedDeliveryCalendar['sale_orders'] !== null && 
    selectedDeliveryCalendar['sale_orders'].includes("undelivered") ) 
    && (cutOffTime !== null && 
    (cutOffTime[0]['orderDeliveryDate'] !== cutOffTime[0]['storeDeliveryDate'] || 
    (cutOffTime[0]['orderDeliveryDate'] === cutOffTime[0]['storeDeliveryDate'] && 
    cutOffTime[0]['currentDateAndtime'] < cutOffTime[0]['storeCutOffTime'])))) {
        return true;
    }  else if( cutOffTime !== null &&  cutOffTime[0]['orderPresent'] === 'yes' && cutOffTime[0]['orderStatus'] === 'undelivered') {
        return true;
    } else {
        return false;
    }
}
export function checkDeliveryCalenderAndCutOffTimes(delivery_date): boolean {
    let selectedDeliveryCalendar = {};
    let cutOffTime = [];
    let deliveryCalendar = JSON.parse(sessionStorage.getItem('event_details'));

    // Find the selected delivery date object from the deliveryCalendar array
    if (deliveryCalendar && Array.isArray(deliveryCalendar)) {
        selectedDeliveryCalendar = deliveryCalendar.find(
            (event: any) => event.event_date === delivery_date
        ) || {};
    }

    cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    if(selectedDeliveryCalendar !== null && selectedDeliveryCalendar['sale_orders'] !== null && 
    selectedDeliveryCalendar['sale_orders'].includes("undelivered") ){
        return true;
    }else {
        return false;
    }
}
export function checkLessThanCutOffTime(): boolean {
    if(sessionStorage.getItem('cutoff') !== '' && sessionStorage.getItem('cutoff') !== null && 
    JSON.parse(sessionStorage.getItem('cutoff'))[0]['orderDeliveryDate'] ===  JSON.parse(sessionStorage.getItem('cutoff'))[0]['storeDeliveryDate'] &&  
    JSON.parse(sessionStorage.getItem('cutoff'))[0]['currentDateAndtime'] > JSON.parse(sessionStorage.getItem('cutoff'))[0]['storeCutOffTime']) {
        return true;
    } else {
        return false;
    }
}
export function getLocalStorage(values, decimalPipe) {
    let localStorageCartProd =  JSON.parse(sessionStorage.getItem('cart'));
    let cartProducts = localStorageCartProd.filter(val => {
        val['quantityArray'] = calculateAvailableQuantityFast(val);
        val['isDisabled'] = true;
        return val;
    });
    let cartProductPrice = cartProducts.reduce( (total, currentValue) =>  {
      let price = decimalPipe.transform(decimalPipe.transform(currentValue['quantity'] * currentValue['product']['retail_price'],  '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
      return total + parseFloat(price);
    }, 0);
    let totalBottles =  cartProducts.filter(val => {
      if(val['product']['bottle_charge'] === true) {
        return val['quantity']; 
      }
    });
    let totalBottlesCount = totalBottles.reduce((a, val) => a + parseInt(val['quantity']) , 0);
    let totalBottlePrice = 0;
    if(values['rate_per_bottle']) {
        totalBottlePrice = (totalBottlesCount * values['rate_per_bottle']);
    }
    let subTotal = cartProductPrice;
    let deliveryFee = subTotal >= values['delivery_upper_limit'] ? 0 : values['delivery_fee'];
    let grandTotal = subTotal + deliveryFee + totalBottlePrice;
    return {grandTotal:subTotal, cartProducts: cartProducts};
}
export function DestroySubscribers() {  
    return function (target: any) {
      // decorating the function ngOnDestroy
      target.prototype.ngOnDestroy = ngOnDestroyDecorator(target.prototype.ngOnDestroy);
      // decorator function
      function ngOnDestroyDecorator(f) {
        return function () {
          // saving the result of ngOnDestroy performance to the variable superData 
          let superData = f ? f.apply(this, arguments) : null;
          // unsubscribing
          for (let subscriberKey in this.subService) {
            let subscriber = this.subService[subscriberKey];
            if (subscriber instanceof Subscriber) {
                console.log('subscriber',subscriber);
                
              subscriber.unsubscribe();
            }
          }
          // returning the result of ngOnDestroy performance
          return superData;
        }
      }
      // returning the decorated class
      return target;
    }
  } 

  export function calculateAvailableQuantityFast(product) {
    let featureTags = JSON.parse(sessionStorage.getItem('featureTags'));
    if(!!featureTags && featureTags['sf_set_max_qty_zero']){
        var availableQuantities = [];
        if(!!product['product']['website_custom_qty']) {
          availableQuantities = product['product']['website_custom_qty'].split(',').map(Number);
        } else if(!!product['product']['website_min_qty'] && !!product['product']['website_max_qty'] && product['product']['website_min_qty'] !== '' && product['product']['website_max_qty'] !== '' && product['product']['website_max_qty'] !== '0') {
          if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no' ) {
            for (let i = parseInt(product['product']['website_min_qty'], 10); i <= parseInt(product['product']['website_max_qty'], 10); i++) {
              availableQuantities.push(i);
            }
          } else  if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'yes') {        
            for (let i = parseFloat(product['product']['website_min_qty']); i <= parseFloat(product['product']['website_max_qty']); i += 0.5) {
              availableQuantities.push(i);
            }
          }
        }  else if(product['product']['website_min_qty'] !== '' && (product['product']['website_max_qty'] === '' || product['product']['website_max_qty'] === 0)) {
          if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no' ) {
            availableQuantities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
              18, 19, 20, 21, 22, 23, 24, 25
            ];
          } else   if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'yes') {
            availableQuantities = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];          
          }
        } else if(product['product']['website_max_qty'] === '0' ){
            if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no') {
                let start = product['product']['website_min_qty'] !== '' ? parseInt(product['product']['website_min_qty'], 10) : 1;
                for (let i = start; i <= 100; i++) {
                    availableQuantities.push(i);
                }
            } else {
                let start = product['product']['website_min_qty'] !== '' ? parseFloat(product['product']['website_min_qty']) : 1;
                for (let i = start; i <= 100; i += 0.5) {
                    availableQuantities.push(i);
                }
            }
        }
        else if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no' ) {
            availableQuantities = getQuantities();
        } else if(product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'yes') {
                if(!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ) {
                    availableQuantities = getQuantities();
                } else {
                    availableQuantities = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];
                }
        }
        return availableQuantities;
    }else{
        var availableQuantities = [];
        if(!!product['product']['website_custom_qty']) {
          availableQuantities = product['product']['website_custom_qty'].split(',').map(Number);
        } else if(!!product['product']['website_min_qty'] && !!product['product']['website_max_qty'] && product['product']['website_min_qty'] !== '' && product['product']['website_max_qty'] !== '') {
          if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no' ) {
            for (let i = parseInt(product['product']['website_min_qty'], 10); i <= parseInt(product['product']['website_max_qty'], 10); i++) {
              availableQuantities.push(i);
            }
          } else  if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'yes') {        
            for (let i = parseFloat(product['product']['website_min_qty']); i <= parseFloat(product['product']['website_max_qty']); i += 0.5) {
              availableQuantities.push(i);
            }
          }
        }  else if(product['product']['website_min_qty'] !== '' && (product['product']['website_max_qty'] === '' || product['product']['website_max_qty'] === 0)) {
          if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no' ) {
            availableQuantities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
              18, 19, 20, 21, 22, 23, 24, 25
            ];
          } else   if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'yes') {
            availableQuantities = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];          
          }
        } else if (product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'no' ) {
            availableQuantities = getQuantities();
        } else if(product['product']['cb_unit_of_measurement']['allow_decimal_quantities'] === 'yes') {
                if(!!product['product']['sell_in_uof'] && product['product']['sell_in_uof'] === 'unit' ) {
                    availableQuantities = getQuantities();
                } else {
                    availableQuantities = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];
                }
        }
        return availableQuantities;
    }

}
export function getQuantities() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
        18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
        35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
        52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
        69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
    ];
}

export function getCartDetails(
    apiService: ApiService,
    sharedDataService: SharedDataService
  ) {
    let query = {};
    if (checkDeliveryCalendarOrderStatus("undelivered") &&
      (checkCutoffDate('!==') || checkCutoffDate('===') && checkCutoffTime('<'))) {
      query['edit_cart'] = 3;
    }
    apiService.getCart(query).subscribe(data => {      
      if (data['response']['status'] === 1) {
        let cartList = data['response']['data']['cart_product_list'];
        sessionStorage.setItem('cart', JSON.stringify( data['response']['data']['cart_product_list']));
        let cartItem = { items: cartList.length, total: 0 };
        sharedDataService.cartDataSource.next(cartItem);
      }
    });
}

export function getSaleOrderDetails(
    apiService: ApiService,
    sharedDataService: SharedDataService
  ) {
    apiService.getSaleOrders().subscribe((data) => {
      if (data['response']['status'] === 1) {
        let resData = data['response']['data'];
        let undeliveredOrder = resData['undelivered_order'];
        let saleOrderItems = undeliveredOrder[0]?.sale_order_items || [];
        let totalPayable = undeliveredOrder[0]?.total_payable || 0;
        let cartItem = { items: saleOrderItems.length, total: totalPayable };
        sharedDataService.cartDataSource.next(cartItem);
      }
    });
}

export function getSaleOrder(
    apiService: ApiService,
    sharedDataService: SharedDataService
  ) {
    // apiService.saleOrders({}).subscribe(result => {
    //     if (result['response']['status'] === 1) {
    //         let cartItem = result['response']['data']['sale_orders']

    //         // Update header cart count
    //         let cartCount = cartItem.reduce(
    //             (acc, saleOrder: any) => {
    //             acc.items += saleOrder.sale_order_items.length;
    //             acc.total += saleOrder.total_payable;
    //             return acc;
    //             },
    //             { items: 0, total: 0 }
    //         );                    
          
    //         // Update the shared data service
    //         sharedDataService.cartDataSource.next(cartCount);
    //     }
    // });
}